// extracted by mini-css-extract-plugin
module.exports = {"menuContent":"_1ZSJw"};